import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@sternum/web/store';

import {
  hideDashboardMenuAction,
  setIsAutoExpandedAction,
  setIsDashboardMenuVisibleAction,
  setIsFullMenuVisibleAction,
  showDashboardMenuAction,
  toggleIsFullMenuVisibleAction,
} from '../slice';

export function useMenu() {
  const dispatch = useAppDispatch();
  const isFullMenuVisible = useAppSelector((state) => state.appContainerWithMenu.isFullMenuVisible);
  const isDashboardMenuVisible = useAppSelector((state) => state.appContainerWithMenu.isDashboardMenuVisible);

  const setIsFullMenuVisible = useCallback(
    (isFullMenuVisible: boolean) => {
      dispatch(setIsAutoExpandedAction(false));

      return dispatch(setIsFullMenuVisibleAction(isFullMenuVisible));
    },
    [dispatch],
  );

  const setIsDashboardMenuVisible = useCallback(
    (isDashboardMenuVisible: boolean) => {
      return dispatch(setIsDashboardMenuVisibleAction(isDashboardMenuVisible));
    },
    [dispatch],
  );

  const showDashboardMenu = useCallback(() => {
    return dispatch(showDashboardMenuAction());
  }, [dispatch]);

  const hideDashboardMenu = useCallback(() => {
    return dispatch(hideDashboardMenuAction());
  }, [dispatch]);

  const handleMenuButtonClick = useCallback(() => {
    dispatch(setIsAutoExpandedAction(false));

    return dispatch(toggleIsFullMenuVisibleAction());
  }, [dispatch]);

  return {
    isFullMenuVisible,
    setIsFullMenuVisible,
    isDashboardMenuVisible,
    setIsDashboardMenuVisible,
    showDashboardMenu,
    hideDashboardMenu,
    handleMenuButtonClick,
  };
}
